<div class="instructions-container">
  <div class="instructions-toggle">
    <button (click)="showInstructions = false" *ngIf="showInstructions">
      <i class="flaticon-cancel"></i> Close Instructions
    </button>
    <button (click)="showInstructions = true" *ngIf="!showInstructions">
      <i class="flaticon-exclamation-2"></i> Open Instructions
    </button>
  </div>
  <div class="instructions" *ngIf="showInstructions">
    <div class="steps-container">
      <div class="step">
        <div>
          <h5>Record</h5>
          <p>
            Press red button to start. Hold the space bar to add a flash. 
          </p>
        </div>

        <div>
          <h5>Tap</h5>
          <p>
            Modify flashes using the text fields or by dragging when selected. 
          </p>
        </div>
      </div>
      <div class="step">
        <div>
          <h5>Delete</h5>
          <p>
            Delete flashes using the Delete key (FN + Delete on Mac). 
          </p>
        </div>
        <div>
          <h5>Preview</h5>
          <p>
            Preview by pressing the red "record" button or white box icon. 
          </p>
        </div>
      </div>
    </div>
  </div>
</div>
